package com.essntl.features.invoice.ui.addeditinvoice.components

import androidx.compose.foundation.layout.Box
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceState
import com.essntl.features.invoice.ui.addeditinvoice.components.sidebar.AddEditInvoiceTotalSection

@Composable
fun AddEditInvoiceSideBarTotal(
    state: AddEditInvoiceState,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier = modifier,
    ) {
        AddEditInvoiceTotalSection(state = state)
    }
}